var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { html, LitElement } from 'lit';
import { customElement, state } from 'lit/decorators.js';
import { Event } from "../models/enums";
import { DataStore } from '../services/datastore.service';
import { EventBus } from '../services/eventbus.service';
let AppRegister = class AppRegister extends LitElement {
    constructor() {
        super();
        this._firstname = "";
        this._lastname = "";
        this._email = "";
        this.loading = false;
        this.registered = false;
        this.error = undefined;
        this.datastore = DataStore.getInstance();
        this.eventbus = EventBus.getInstance();
        this.datastore.clearData();
    }
    createRenderRoot() {
        return this;
    }
    updateValues() {
        this._firstname = document.getElementById("firstname").value;
        this._lastname = document.getElementById("lastname").value;
        this._email = document.getElementById("email").value;
    }
    register() {
        this.loading = true;
        this.error = undefined;
        this.datastore.registerUser(this._firstname, this._lastname, this._email)
            .then(() => {
            this.eventbus.dispatchEvent(Event.Toast, {
                text: "User registered successfully",
                classes: "fas fa-user",
                type: "is-info",
            });
            this.registered = true;
        })
            .catch((error) => {
            this.eventbus.dispatchError(error);
            this.requestUpdate();
        })
            .finally(() => this.loading = false);
    }
    render() {
        return html `
      ${this.registered ? html `
      <div class="card">
        <div class="card-content">
          <div class="mt-2 mb-2 text-centered">
            <b>Registration saved</b><br>
            <br>
            Please check your <span class="has-text-weight-bold">${this._email}</span> inbox or junk-folder for your verification email. Either click the link in the mail or copy
            and paste into a browser to complete your registration.<br>
          </div>
        </div>
      </div>
      ` : html `
      <div class="card">
        <div class="card-content">
          <div class="mt-2 mb-2">

            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input id="firstname" class="input" type="text" placeholder="Firstname" @change=${this.updateValues} />
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </div>
            </div>
            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input id="lastname" class="input" type="text" placeholder="Lastname" @change=${this.updateValues} />
                <span class="icon is-small is-left">
                  <i class="fas fa-user"></i>
                </span>
              </div>
            </div>

            <div class="field">
              <div class="control has-icons-left has-icons-right">
                <input id="email" class="input" type="email" placeholder="Email" @change=${this.updateValues} />
                <span class="icon is-small is-left">
                  <i class="fas fa-at"></i>
                </span>
              </div>
            </div>

            <div class="field is-grouped">
              <div class="control">
                <button class="button is-primary" @click="${this.register}" ?disabled=${this.loading}>
                  <span class="icon">
                    ${this.loading ? html `
                    <i class="fas fa-circle-notch fa-spin"></i>
                    ` : html `
                    <i class="fas fa-user-check"></i>
                    `}
                  </span>
                  <span>Register</span>
                </button>
              </div>
            </div>

          </div>
        </div>
      </div>

      ${this.error ? html `
      <div class="notification is-danger mt-4 has-text-centered">
        ${this.error}
      </div>
      ` : ''}

      `}
    `;
    }
};
__decorate([
    state()
], AppRegister.prototype, "loading", void 0);
AppRegister = __decorate([
    customElement('app-register')
], AppRegister);
export { AppRegister };
//# sourceMappingURL=anon_register.js.map